import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import {
    MaterialFormsModule,
    MaterialUserInterfaceModule,
} from 'ng2-material-components/ng2-material-components';

import { ClockInOutComponent }   from './clock-in-out.component';
import { LocationLogsComponent, EmployeeLogComponent } from './shared/ui';

import { ClockInOutService } from './shared/services';

import { CapitalizePipe, DurationPipe } from '../shared/pipes';


@NgModule({
    imports: [
        CommonModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        SharedModule,
    ],
    exports: [
        ClockInOutComponent,
    ],
    declarations: [
        ClockInOutComponent,
        LocationLogsComponent,
        EmployeeLogComponent,
        CapitalizePipe,
        DurationPipe
    ],
    providers: [
        ClockInOutService
    ],
})
export class ClockInOutModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/clock-in-out.module.ts